import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Carousel } from "@domain/carousel/carousel";
import { Article } from "@domain/lms/article/article";
import { Course } from "@domain/lms/course/course";
import { ArticleThumbnail } from "@ui/components/article/articleThumbnail";
import { Secondary } from "@ui/components/containers/textBlocks";
import { CourseThumbnail } from "@ui/components/course/courseThumbnail";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { CarouselThumbnail } from "@ui/components/pdfCarousel/carouselThumbnail";
import { desktop, gap, mobile } from "@ui/styles/utils";
export type ProfileFavoriteContent = Article | Course | Carousel;

interface FavoriteAllListProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "content"> {
	totalElements: number | undefined;
	content: ProfileFavoriteContent[];
	loading: boolean;
	moreLoading: boolean;
	fetchMore: () => Promise<void>;
}

export const FavoriteAllList: React.FC<FavoriteAllListProps> = ({
	totalElements = 0,
	content,
	loading,
	moreLoading,
	fetchMore,
	...htmlProps
}) => {
	if (totalElements === 0) {
		return <Secondary>{I18n.t("profile.favorite.empty")}</Secondary>;
	}
	return (
		<InfiniteScroll onEndReached={fetchMore} loading={loading || moreLoading}>
			<Element {...htmlProps}>
				{" "}
				{content.map((elmt) => (
					<>
						{elmt.contentType === "COURSE" && <CourseThumbnail key={elmt.id} course={elmt as Course} />}
						{elmt.contentType === "ARTICLE" && <ArticleThumbnail key={elmt.id} article={elmt as Article} />}
						{elmt.contentType === "CAROUSEL" && <CarouselThumbnail key={elmt.id} carousel={elmt as Carousel} />}
					</>
				))}
			</Element>
			{loading && moreLoading && <ClipLoader />}
		</InfiniteScroll>
	);
};

const Element = styled.div`
	@media ${desktop} {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 20px;
	}
	@media ${mobile} {
		${gap(20)};
	}
`;
